import React from "react";
import { alpha, Button, useTheme } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

interface ContactChannelsButtonProps {
  onClick: () => void;
  buttonRef?: React.RefObject<HTMLButtonElement>;
}

const ContactChannelsButton: React.FC<ContactChannelsButtonProps> = ({
  onClick,
  buttonRef,
}) => {
  const theme = useTheme();
  return (
    <Button
      ref={buttonRef}
      onClick={onClick}
      startIcon={<WhatsAppIcon />}
      sx={{
        fontWeight: 600,
        fontSize: "16px",
        color: "primary.main",
        textTransform: "none",
        whiteSpace: "nowrap",
        "&:hover": {
          backgroundColor: alpha(theme.palette.primary.main, 0.04),
        },
      }}
    >
      Canais de Atendimento
    </Button>
  );
};

export default ContactChannelsButton;
